import { Identifiable, Project } from "@planzone/dto";
import { Selector, State } from "./types";

// A single listing is kept, the one of the last requested project.
function get(getState: () => State, project: Identifiable<Project>) {
  const state = getState();

  return state.project && state.project.uuid === project.uuid
    ? state
    : undefined;
}

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveProjectResourcesListingRequestPending(project) {
      const state = get(getState, project);

      return state ? state.request.isPending : false;
    },
    isRetrieveProjectResourcesListingRequestSuccess(project) {
      const state = get(getState, project);

      return state ? state.request.isSuccessful : false;
    },
    isRetrieveProjectResourcesListingRequestFailure(project) {
      const state = get(getState, project);

      return state ? state.request.isFailure : false;
    },
    getProjectResourcesListing(project) {
      const state = get(getState, project);

      return state ? state.projectResources : [];
    },
    getProjectResourcesListingTotalPages(project) {
      const state = get(getState, project);

      return state ? state.totalPages : 0;
    },
    getProjectResourcesListingFilter() {
      return getState().filter;
    },
  };
}

export { createSelector };
